<div class="kb-container" *ngIf="!isLoadingKb && !isLoadingLabels">
	<div class="navigation">
		<span (click)="emitLeavePage()">< {{ labels.lbl_geral_inicio }}</span>
		<span (click)="view = 'kb'">< KB - {{ kb.id }}</span>
		<span (click)="view = 'evaluateKb'; fillUntilStar(evaluationPointUntil)" *ngIf="isEvaluationGoingOn">
			< {{ labels.lbl_geral_avaliacao }}</span
		>
	</div>

	<div *ngIf="view === 'kb'">
		<div class="button-container">
			<div class="button" (click)="view = 'evaluateKb'; isEvaluationGoingOn = true; fillUntilStar(evaluationPointUntil)">
				{{ labels.lbl_geral_avaliar }}
			</div>
		</div>
		<div class="kb-general-info-container">
			<div class="input-row"><span class="label">ID: </span><input type="text" disabled [value]="kb.id" /></div>
			<div class="input-row">
				<span class="label">{{ labels.lbl_geral_versao }}: </span><input type="text" disabled [value]="kb.version" />
			</div>
			<div class="input-row">
				<span class="label">{{ labels.lbl_edocs_data_versao }}: </span
				><input type="text" disabled [value]="DateService.formatDate(kb.version_date.toString())" />
			</div>
			<div class="input-row">
				<span class="label">{{ labels.lbl_kb_pontos }}: </span><input type="text" disabled [value]="kb.points" />
			</div>
		</div>

		<div class="kb-content-container">
			<div class="label">{{ labels.lbl_geral_summary }}:</div>
			<div [innerHtml]="kb.summary"></div>

			<div class="label">{{ labels.lbl_geral_descricao }}:</div>
			<div [innerHtml]="kb.description"></div>
		</div>
	</div>

	<div *ngIf="view === 'evaluateKb'">
		<div class="evaluation-container">
			<div>
				<span class="label">{{ labels.lbl_rate_file }}: </span>
				<span
					class="star star-{{ index }}"
					*ngFor="let e of [].constructor(5); let index = index"
					(mouseenter)="fillUntilStar(index)"
					(mouseleave)="fillUntilStar(evaluationPointUntil)"
					(click)="evaluationPointUntil = index">
					<fa-icon [icon]="faStar"></fa-icon>
				</span>
			</div>
			<div>
				<span class="label">{{ labels.lbl_leave_a_comment }}:</span>
			</div>
			<div><textarea rows="4" [value]="evaluationCommentary" (input)="evaluationCommentary = $event.target.value"></textarea></div>
			<div class="button-container">
				<div class="button" (click)="resetEvaluation()">{{ labels.lbl_geral_cancelar }}</div>
				<div class="button" (click)="submitEvaluation()">{{ labels.lbl_geral_salvar }}</div>
			</div>
		</div>
	</div>
</div>

<div class="loading-container" *ngIf="isLoadingKb || isLoadingLabels">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
